import { create } from 'zustand';
import { DeviceType } from '../enum/EnumRepository';
import { getCurrentScreenDeviceType } from '../util/deviceUtils';


interface DeviceState {
  deviceType: DeviceType;
  detectDevice: () => void;
}

export const useDeviceStore = create<DeviceState>((set, get) => ({
  deviceType: getCurrentScreenDeviceType(),
  detectDevice: () => {
    const currentDeviceType = get().deviceType;
    const newDeviceType = getCurrentScreenDeviceType();

    // 디바이스 타입이 실제로 변경된 경우에만 상태 업데이트
    if (currentDeviceType !== newDeviceType) {
      console.log(`🔄 [DeviceStore] Device type changed: ${currentDeviceType} → ${newDeviceType}`);
      set({ deviceType: newDeviceType });
    }
  },
})); 